import React from 'react';

import './InspirationPage.scss';

/**
 * Placeholder page until the page is designed
 */

const InspirationPageComponent = () => (
  <div className="inspirationpage-component">
    <h1>Inspiration Page</h1>
  </div>
);

InspirationPageComponent.displayName = 'InspirationPage';

export default InspirationPageComponent;
